<template>
    <div class="device-data">
        <div class="content">

          <p v-if="originalObservations" style="color:black;">Valitse näytettävät arvot</p>
            <div v-for="(observation, index) in originalObservations" :key="index" style="display:inline-block; margin-right:20px;">
              <label class="label-chart-checkbox">
                <input type="checkbox" :checked="observation.visible" @change="toggleVisibility(index)" /> {{ observation.title }}
              </label>
            </div>

            <div v-if="showStatusMessage" class="status-indicator">
                <p>{{statusMessage}}</p>
                <p><hollow-dots-spinner v-if="isFetchingResults()"
                                    :animation-duration="1000"
                                    :dot-size="22"
                                    :dots-num="3"
                                    class="dot-spinner"
                                    color="red"
                /></p>
            </div>
            <br>

            <p v-if="noDevices">Hakuehdoilla ei löytynyt arvoja.</p>

            <div class="good-days" v-if="showRangeSliders" :id="'slider' + deviceId">
                <div class="section-header"><h2>Arvorajojen suodattimet</h2></div>
                <div class="slider-description">
                    <p>Suodata päivät päivien min ja max raja-arvojen perusteella. Liukusäätimen minimi rajaa pois
                    päivät joiden minimi on pienempi kuin liukusäätimen arvo. Liukusäätimen maksimi rajaa pois päivät
                    missä päivän maksimi on isompi kuin liukusäätimen arvo.</p>
                </div>
                <div v-if="Object.keys(sliderData.sliderIds).length !== 0" v-for="id in sliderData.sliderIds" style="color: #000; margin-bottom: 25px">
                    <div class="slider-label">{{id}}</div>
                    <div class="range-slider">
                        <vue-slider
                                ref="slider"
                                v-model="sliderData.sliderValues[id].values"
                                v-bind="options"
                                :min="sliderData.sliderValues[id].min"
                                :max="sliderData.sliderValues[id].max"
                                @change="sliderChange(
                                    sliderData.sliderValues[id].values,
                                    id,
                                    sliderData.sliderValues[id].observationName
                                    )"
                        ></vue-slider>
                    </div>
                </div>
                <div class="days-in-ranges">
                    <div class="slider-day-labels">
                        <span class="in-range-label">Päivät rajojen sisäpuolella</span>
                        <span>/</span>
                        <span class="out-of-range-label">Päivät rajojen ulkopuolella</span>
                    </div>
                    <div class="days-in-ranges-values">
                        <span class="in-range">{{daysInRange}}</span>
                        <span class="separator">/</span>
                        <span class="out-of-range">{{daysOutOfRange}}</span>
                    </div>
                </div>
            </div>

            <CombinationCharts
                    v-if="showCombinationCharts"
                    :observationNames="observationNames"
                    :deviceId="deviceId"
            />

            <Charts
                    v-if="haveObservations"
                    :amountOfCharts="amountOfCharts"
                    :chartsTagId="chartsTagId"
                    :deviceId="deviceId"
                    :deviceName="deviceName"
                    :chartUnits="chartUnits"
                    :chartTypes="chartTypes"
                    :observationTypes="observationTypes"
                    :parentParentSetContentToBeAddedToBillingPdf="parentSetContentToBeAddedToBillingPdf"
                    :parentParentCreateInitialBillingPdf="parentCreateInitialBillingPdf"
            />

            <div class="dataTableContainer" >
                <div v-if="haveObservations">
                    <div class="section-header">
                        <h2>Vapaa teksti</h2>
                    </div>
                    <div class="extra_text_component">
                        <input id="extra_text_button" type="button" v-on:click="showExtraField = !showExtraField" value="Lisää vapaa teksti"><br/>
                        <input :id="extraTextFieldId" type="text" v-if="showExtraField" class="extra_text_field" value="">
                    </div>
                </div>

                <div v-if="haveObservations">
                    <div class="section-header">
                        <h2>Taulukko</h2>
                    </div>

                    <h2 style="color: black;">Suodata:</h2>
                    <div class="filter_component"
                         :id="'filter_component_' + deviceId">
                        <select class="filter_options">
                            <option></option>
                        </select>
                        <select class="filter_operand">
                            <option></option>
                            <option value="<">pienempi kuin</option>
                            <option value=">">suurempi kuin</option>
                        </select>
                        <input class="filter_value" type="text" value="">
                        <input type="button" v-on:click="addFilter()" value="Lisää suodatin">
                        <div class="active_filters" style="color: #333333">
                            <div class="active_filter" v-for="filter in filters"><button v-on:click="removeFilter(filter)">{{filter.name}} {{filter.operand}} {{filter.value}} <span class="red-x">x</span></button></div>
                        </div>
                    </div>

                    <h2 style="color: black;">Pyöristä:</h2>
                    <div class="round_component"
                         :id="'round_component_' + deviceId"
                    >
                        <select class="round_options"></select>
                        <select class="round_type">
                            <option value="0">0</option>
                            <option value="1">0.0</option>
                            <option value="2">0.00</option>
                        </select>
                        <input type="button" v-on:click="modifyDecimals()" value="Päivitä">

                    </div>
                </div>

                <table :id="tableTagId" class="table table-striped table-bordered">
                    <thead>
                    <tr>
                        <th v-for="header in tableData.headers">{{header}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="row in tableData.rows">
                        <td v-for="data in row">{{data}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from '../../service/EventBus';
    import { default as Charts} from './Charts';
    import { default as CombinationCharts } from './CombinationCharts';
    import { FoxEnvs } from '../../service/foxeriot_environments';
    import axios from 'axios';
    import Chart from 'chart.js';
    import ChartTimeline from 'chartjs-chart-timeline';
    import { HollowDotsSpinner } from 'epic-spinners';

    require('jquery')
    let dt = require('datatables.net')
    require('datatables.net-bs4')

    let buttons = require('datatables.net-buttons')

    require('datatables.net-buttons-bs4')
    require('datatables.net-buttons/js/buttons.colVis.min.js')
    require('datatables.net-buttons/js/buttons.html5.min.js')
    require('datatables.net-buttons/js/buttons.flash.min.js')
    require('datatables.net-buttons/js/buttons.print.min.js')

    import pdfMake from 'pdfmake/build/pdfmake'
    import pdfFonts from 'pdfmake/build/vfs_fonts'

    import vueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/antd.css'

    pdfMake.vfs = pdfFonts.pdfMake.vfs

    require('datatables.net-bs4/css/dataTables.bootstrap4.css')

    let allowedObservations = [
      "humidity1", "humidity2", "temperature1", "temperature2",
      "temperature", "humidity", "Pa", "CO2", "PM1", "PM2.5", "PM10"
    ];


    export default {
        name: "device-data",
        components: {
            Charts,
            CombinationCharts,
            vueSlider,
            HollowDotsSpinner,
        },
        props: {
            deviceName: String,
            deviceId: String,
            parent_times: Object,
            chartsTagId: String,
            tableTagId: String,
            extraTextFieldId: String,
            tableColumnsCount: Number,
            parentShowSmallCharts: Boolean,
            parentStartGraphFromZero: Boolean,
            parentSetContentToBeAddedToBillingPdf: Function,
            parentCreateInitialBillingPdf: Function,
            visible: true
        },
        data() {
            return {
                fetchingResults: false,
                combinationChart: null,
                combinationChartLeftYName: null,
                combinationChartRightYName: null,
                observationNames: false,
                observationTypes: [],
                haveObservations: true,
                sliderData: {
                    datesMinMaxes: {},
                    sliderValues: {}
                    },
                daysInRange: 0,
                daysOutOfRange: 0,
                daysInSelection: 0,
                options: { // for sliders
                    width: "90%",
                    height: 8,
                    dotSize: 20,
                    interval: 0.1,
                    disabled: false,
                    show: true,
                    useKeyboard: true,
                    tooltip: "always",
                    formatter: "{value}",
                    enableCross: false,
                    mergeFormatter: "{value1} ~ {value2}",
                    bgStyle: {
                        "background-color": "rgb(255, 255, 255)",
                        "box-shadow": "rgba(0, 0, 0, 0.36) 0.5px 0.5px 3px 1px inset"
                    },
                    tooltipStyle: {
                        "backgroundColor": "#666",
                        "borderColor": "#666",
                        "padding": "2px 5px"
                    },
                    processStyle: {
                        "backgroundColor": "#999"
                    }
                },
                token: null,
                tempData: null,
                chartsForDestroy: [],
                datatable: null,
                noDevices: false,
                amountOfCharts: 0,
                datatableReadyToInitialize: false,
                statusMessage: '',
                showStatusMessage: false,
                tableData: {
                    headers: [],
                    rows: []
                },
                showExtraField: false,
                chartType: 'line',
                chartTypes: ['line', 'bar'],
                chartUnits: [],
                allowedObservations: allowedObservations,
                observationSets: [],
                originalObservations: [],
                formattedObservationSets: [],
            }
        },
        methods: {
          async toggleVisibility(index) {
            if (this.observationSets && this.observationSets[index]) {
              const newVisibility = !this.observationSets[index].visible;
              this.$set(this.observationSets[index], 'visible', newVisibility);
              this.$set(this.originalObservations[index], 'visible', newVisibility);
              await this.$nextTick()
              this.destroyOldCharts()
              await this.recreateCharts();
              await this.$nextTick();
              this.initializeTable();
            }
          },
            async getAndSetDeviceObservations(deviceId, times, visibleObservations) {
              this.daysInRange = 0
              this.daysOutOfRange = 0
              this.haveObservations = false
              this.noDevices = false
              this.showStatusIndicator('Ladataan...')
              this.fetchingResults = true

              await this.$store.dispatch('addObservationStatus', {
                deviceId: deviceId,
                loading: true
              })

              let oneMonthInMilliseconds = 2592000000
              let limit = oneMonthInMilliseconds * 6
              if (times.start.getTime() < times.end.getTime() - limit) {
                this.showStatusIndicator('Liian suuri aikaväli, maksimi aikaväli on 6 kuukautta.')
                return false;
              }

              let params2 = {
                deviceId: deviceId,
                limit: 10000,
                notBefore: times.start,
                notAfter: times.end
              };

              let doNotDoIt = false
              let observations = []
              if (visibleObservations) {
                doNotDoIt = true
                observations = visibleObservations
              } else {
                observations = visibleObservations || this.$store.getters.devicesObservations[this.deviceId]
              }
              if (observations) {
                this.$store.dispatch('observationsFetchedChange', this.deviceId).then(() => {})
                await this.setChartAndTableData(observations, doNotDoIt)
                this.setCombinationChart(null, observations)
                this.fetchingResults = false
              } else {
                this.getObservationsFromApi(params2)
              }
            },
            isFetchingResults: function() {
                return this.fetchingResults
            },
            getObservationsFromApi(params2) {
                let url = FoxEnvs.prod.baseUrl + '/api/v1/get-observations';
                this.getObservations(url, params2).then((response) => {
                    this.$store.dispatch('observationsFetchedChange', '')
                    this.$store.dispatch('observationsFetchedChange', params2.deviceId).then(() => {})
                    let observationSets = this.addExtraChartDetailsToObservations(response.observationSets);
                    this.setObservationNamesForCombinationCharts(observationSets)
                    this.saveObservationsToStore(observationSets)
                    this.setChartAndTableData(observationSets)
                    this.setCombinationChart()
                    this.fetchingResults = false
                }).catch((error) => {
                    this.fetchingResults = false
                    this.showStatusIndicator('Virhe havaintoja ladatessa')
                    this.$store.dispatch('addObservationStatus', {
                        deviceId: params2.deviceId,
                        loading: false
                    })
                })


            },
            addExtraChartDetailsToObservations(observationSets) {
                let obsSet = [];
                this.observationTypes[this.deviceId] = []
                observationSets.forEach(set => {
                    this.observationTypes[this.deviceId].push('line')
                    set.chartType = 'line'
                    obsSet.push(set)
                })
                return obsSet
            },
            setObservationNamesForCombinationCharts(observationSets) {
                this.observationNames = []
                observationSets.forEach(set => {
                    this.observationNames.push(set.variable)
                })
            },
            setCombinationChart(combinationData = null, Observations = null) {
                if (
                    (!this.combinationChartLeftYName || !this.combinationChartRightYName)
                    && !combinationData
                ) {
                    // There is data change but no combination chart
                    return
                }
                this.destroyExistingCombinationChart()
                if (combinationData) {
                    this.setCombinationChartYAxesNameInstances(combinationData)
                }

                let canvas = this.getCombinationChartCanvas()
                if (!canvas) {
                    // The canvas is not visible
                    return
                }

              let deviceObservations = null;
              if (!Observations) {
                deviceObservations = this.visibleObservations
              } else {
                deviceObservations = Observations
              }

                let leftAndRightChartData = this.getLeftAndRightChartData(deviceObservations, canvas)
                let combinationChartData = this.combineLeftAndRightChartData(leftAndRightChartData)

                this.combinationChart = this.createChart(combinationChartData)

            },
            destroyExistingCombinationChart() {
                if (this.combinationChart) {
                    this.combinationChart.destroy()
                    this.combinationChart = null
                }
            },
            setCombinationChartYAxesNameInstances(combinationData) {
                this.combinationChartLeftYName = combinationData.left
                this.combinationChartRightYName = combinationData.right
            },
            getCombinationChartCanvas() {
                let canvasId = 'combination-chart-' + this.deviceId
                return document.getElementById(canvasId)
            },
            getLeftAndRightChartData(deviceObservations, canvas) {

                let leftObservations = deviceObservations.filter(observationsData => {
                    return observationsData.variable === this.combinationChartLeftYName
                })[0]

                let rightObservations = deviceObservations.filter(observationsData => {
                    return observationsData.variable === this.combinationChartRightYName
                })[0]

                leftObservations = this.formatObservationSet(leftObservations)
                rightObservations = this.formatObservationSet(rightObservations)

                let leftChartData = this.formatChartData(leftObservations, canvas)
                let rightChartData = this.formatChartData(rightObservations, canvas)

                return {
                    leftData: leftChartData,
                    rightData: rightChartData,
                }
            },
            combineLeftAndRightChartData(leftAndRightChartData) {
                let leftChartData = leftAndRightChartData.leftData
                let rightChartData = leftAndRightChartData.rightData

                leftChartData.dataString.datasets[0].backgroundColor = 'rgba(204,0,0,1)'
                leftChartData.dataString.datasets[0].borderColor = 'rgba(204,0,0,1)'

                let combinationChartData = leftChartData

                let rightChartDataSet = rightChartData.dataString.datasets[0]
                rightChartDataSet.yAxisID = "y-axis-2"
                let rightYAxesData = rightChartData.yAxesData[0]
                rightYAxesData.position = 'right'
                rightYAxesData.id = 'y-axis-2'

                combinationChartData.dataString.datasets.push(rightChartDataSet)
                combinationChartData.yAxesData.push(rightYAxesData)

                return combinationChartData
            },
            saveObservationsToStore(observationSets) {
                let observationsAndId = {
                    deviceId: this.deviceId,
                    observationSets: observationSets
                }
                this.$store.dispatch('addObservationSet', observationsAndId)
            },
            filterOutDummyObservations(observationSets) {
                let filteredObservations = [];

                observationSets.forEach(set => {
                  if (this.allowedObservations.includes(set.title) && !set.title.includes('device_service_')) {
                    filteredObservations.push(set);
                  }
                })

                return filteredObservations;
            },
            initSliderDays() {
                this.updateValidDaysCount();
            },
            getDaysBetween( date1, date2 ) {
                let one_day = 1000 * 60 * 60 * 24
                let date1_ms = date1.getTime()
                let date2_ms = date2.getTime()
                let difference_ms = date2_ms - date1_ms
                return Math.round(difference_ms/one_day)
            },
            // name is/was for debugging
            sliderChange(minMax, id, name) {
                this.sliderData.sliderValues[id].values = minMax
                this.updateValidDaysCount()
            },
            updateValidDaysCount() {
                let validDays = []
                let inValidDays = []

                Object.keys(this.sliderData.datesMinMaxes).forEach(date => {
                    Object.keys(this.sliderData.sliderValues).forEach(key => {
                      if (this.sliderData.datesMinMaxes[date] && this.sliderData.datesMinMaxes[date][key]) {
                        let dayMin = parseFloat(this.sliderData.datesMinMaxes[date][key].min)
                        let dayMax = parseFloat(this.sliderData.datesMinMaxes[date][key].max)

                        let sliderMin = parseFloat(this.sliderData.sliderValues[key].values[0])
                        let sliderMax = parseFloat(this.sliderData.sliderValues[key].values[1])

                        let sliderMinSmallerThanDayMin = sliderMin <= dayMin
                        let sliderMaxBiggerThanDayMax = sliderMax >= dayMax

                        if (sliderMinSmallerThanDayMin && sliderMaxBiggerThanDayMax) {
                          if (!validDays.includes(date) && !inValidDays.includes(date)) {
                            validDays.push(date)
                          }
                        } else {
                          if (!inValidDays.includes(date)) {
                            inValidDays.push(date)
                          }
                          if (validDays.includes(date)) {
                            validDays.splice(validDays.indexOf(date), 1)
                          }
                        }
                      }
                    })
                })
                this.daysInRange = validDays.length
                this.daysOutOfRange = inValidDays.length
                this.daysInSelection = this.daysInRange + this.daysOutOfRange
            },
            getObservations: function(url, params) {
                let token = this.$auth.getAuthToken()
                return new Promise((resolve, reject) => {
                    axios.get(url, {
                        params: params,
                        headers: {
                            'Authorization': 'Bearer ' + token,
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    }).then((response) => {
                        let responseData = response.data.data[0];
                        if(responseData) {
                            let url = response.data.next;
                            if (url) {
                                const prefix = url.slice(0, 4);
                                if (prefix !== 'http') {
                                    url = `https://${url}`;
                                }
                                this.getObservations(url, {}).then((resp) => {
                                    if(resp) {
                                        for (let observationSet of responseData.observationSets) {
                                            let row = resp.observationSets.find(i => i.variable === observationSet.variable)
                                            if (row) {
                                                observationSet.observations = observationSet.observations.concat(row.observations)
                                            }
                                        }
                                    }
                                    resolve(responseData);
                                }).catch((error) => {
                                    reject(error)
                                })
                            } else {
                                resolve(responseData);
                            }
                        }else{
                            resolve(responseData);
                        }
                    }).catch(error => {
                        reject(error)
                    })
                })
            },
            async setChartAndTableData(observations, doNotDoIt = false) {
                this.sliderData = {sliderIds: [], datesMinMaxes: {}, sliderValues: {}}
                if (observations) {
                    this.haveObservations = true
                    this.hideStatusIndicator()
                    this.noDevices = false
                  let formattedObservationSets = [];
                  if (doNotDoIt) {
                    formattedObservationSets = observations
                  } else {
                    formattedObservationSets = this.getFormattedObservationSets(observations)
                    this.observationSets = formattedObservationSets;
                    this.originalObservations = formattedObservationSets
                  }

                    this.amountOfCharts = this.countAmountOfCharts(formattedObservationSets)
                    if (this.amountOfCharts > 0) {
                        await this.setCharts(formattedObservationSets)
                        await this.setTableData(formattedObservationSets)
                    }
                } else {
                    this.haveObservations = false
                    this.daysInSelection = 0
                    this.daysInRange = 0
                    this.daysOutOfRange = 0
                    this.showStatusIndicator('Havaintoja ei löydetty')
                }

                // update store for activity timeline
                this.$store.dispatch('addObservationStatus', {
                    deviceId: observations[0].deviceId,
                    loading: false
                })
            },
            countAmountOfCharts(observationSets) {
                let amount = 0
                for (let set of observationSets) {
                    if (set.visible) {
                        amount++
                    }
                }
                return amount
            },
            showStatusIndicator(message) {
                this.showStatusMessage = true
                this.statusMessage = message;
            },

            hideStatusIndicator() {
                this.showStatusMessage = false
            },

            getUniqueIdForDataTable() {
                return "dataTable" + this.deviceId
            },

            getUniqueIdForObservation(index) {
                return index + this.deviceId
            },

            getFormattedObservationSets(observationSets) {
                if (observationSets) {
                    let formattedObservationSets = []
                    this.noDevices = false
                    this.chartUnits = []
                    this.observationTypes[this.deviceId] = []
                    for (let observationSet of observationSets) {
                      let formattedSet = this.formatObservationSet(observationSet)
                      formattedObservationSets.push(formattedSet);
                    }
                    return formattedObservationSets
                } else {
                    this.handleNoDeviceData()
                    return [];
                }
            },

            async setCharts(observationSets) {
                await this.$nextTick();
                    let deviceCharts = await this.getTemplateCharts()
                    let sort = 0
                  for (let observationSet of observationSets) {
                    if (!observationSet.visible) {
                      continue; // Skip rendering if the observation is not visible
                    }

                    let canvasAndId = deviceCharts[sort];
                    if (canvasAndId) {
                      let chartCanvas = canvasAndId.canvas;
                      observationSet.sort = sort;

                      let chartData = this.formatChartData(observationSet, chartCanvas);

                      let maintainAspectRatio = this.$store.getters.showSmallCharts;
                      let chart = this.createChart(chartData, maintainAspectRatio);
                      this.chartsForDestroy.push(chart);

                      this.setChartValuesMeta(chartCanvas, chartData.valuesMeta);

                      let observationName = chartData.dataString.datasets[0].label;

                      this.sliderData.sliderIds.push(observationSet.title);

                      this.setSliderData(chartData.valuesMeta, observationSet.title, observationName);
                      this.setObservationMinAndMaxForEachDay(observationSet.title, observationSet.dataTableRows);

                      sort++;
                    }
                  }
            },

            setSliderData(valuesMeta, observationId, observationName) {
                let min = valuesMeta.min - 1
                let max = valuesMeta.max + 1

                this.$set(this.sliderData.sliderValues, observationId, {
                  values: [min, max],
                  min: min,
                  max: max,
                  observationName: observationName,
                });
            },
            setObservationMinAndMaxForEachDay(observationId, dataTableRows) {
                dataTableRows.forEach((row) => {
                    let dateKey = row.timestamp.substring(0, row.timestamp.lastIndexOf(' '));
                    if (!(dateKey in this.sliderData.datesMinMaxes)) {
                      this.$set(this.sliderData.datesMinMaxes, dateKey, {});
                    }

                    if (!(observationId in this.sliderData.datesMinMaxes[dateKey])) {
                      this.$set(this.sliderData.datesMinMaxes[dateKey], observationId, { min: row.value, max: row.value });
                    } else {
                      if (this.sliderData.datesMinMaxes[dateKey][observationId].min > row.value) {
                        this.sliderData.datesMinMaxes[dateKey][observationId].min = row.value;
                      }
                      if (this.sliderData.datesMinMaxes[dateKey][observationId].max < row.value) {
                        this.sliderData.datesMinMaxes[dateKey][observationId].max = row.value;
                      }
                    }
                });

                //Init rigth amount of days for the slider!
                this.initSliderDays()
            },
            async getTemplateCharts() {
              let deviceCharts = [];
              let visibleChartIndex = 1; // Initialize a counter for visible charts

              await this.$nextTick()
                for (let i = 0; i < this.observationSets.length; i++) {
                  let observationSet = this.observationSets[i];
                  if (observationSet && observationSet.visible) {
                    let canvasId = "deviceCanvas" + this.getUniqueIdForObservation(visibleChartIndex);
                    let canvas = document.getElementById(canvasId);
                    if (canvas) {
                      deviceCharts.push({
                        canvas: canvas,
                        observationId: this.getUniqueIdForObservation(visibleChartIndex)
                      });
                      visibleChartIndex++; // Increment the counter for visible charts
                    }
                  }
                }

                return deviceCharts
            },

            destroyOldCharts() {
              if (this.chartsForDestroy.length !== 0) {
                for (let chart of this.chartsForDestroy) {
                  // Check if the observation is still visible
                  let observation = this.observationSets.find(obs => obs.title === chart.data.datasets[0].label);
                  if (observation && !observation.visible) {
                    chart.destroy();
                    if (chart.chartCanvas && chart.chartCanvas.parentNode) {
                      let parentDiv = chart.chartCanvas.closest('.col-lg-12.graph.charts-stuff.big-charts');
                      if (parentDiv) {
                        parentDiv.remove();
                      }
                    }
                  }
                }
                // Remove only the destroyed charts from the array
                this.chartsForDestroy = this.chartsForDestroy.filter(chart => chart.chartCanvas && chart.chartCanvas.parentNode);
              }
            },

            formatObservationSet(observationSet) {
                let observationData = {
                    id: '',
                    title: '',
                    unit: '',
                    chartType: '',
                    tempDataset: [],
                    timeLabels: [],
                    dataSetDetails: [],
                    xAxesData: [],
                    yAxesData: [],
                    numberOfObservations: 0,
                    allValues: [],
                    dataTableRows: [],
                    sort: 0,
                    visible: false
                }

                observationData.id = observationSet.deviceId
                observationData.title = observationSet.variable
                if (this.allowedObservations.includes(observationSet.variable) && !observationSet.variable.includes('device_service_')) {
                  observationData.visible = true
                }

                observationData.chartType = observationSet.chartType
                this.observationTypes[this.deviceId].push(observationSet.chartType)

                if(observationSet.observations[0] && this.chartUnits !== undefined){
                    if (observationSet.observations[0].unit) {
                        observationData.unit = observationSet.observations[0].unit.toLowerCase();
                    } else {
                        observationData.unit = "";
                    }
                    this.chartUnits.push(observationData.unit);
                }
                for (let obsRow of observationSet.observations) {
                    let isValueTypeNumeric = true;
                    if(observationSet.valueType != "numeric"){
                      isValueTypeNumeric = false;
                    }

                    let timestamp = this.getRowDataTime(obsRow)
                    observationData.timeLabels.push(timestamp)

                    let roundedObsRowValue = 1;
                    let roundedObsRowValueForDataTable = obsRow.value
                    if(isValueTypeNumeric) {
                        roundedObsRowValue = parseFloat(obsRow.value).toFixed(1)
                        let lowercase_title = observationData.title.toLowerCase()
                        if (lowercase_title.includes('lämpötila')) {
                            roundedObsRowValueForDataTable = roundedObsRowValue.replace('.', ',')
                        }
                    }

                    observationData.tempDataset.push(roundedObsRowValue)
                    observationData.allValues.push(roundedObsRowValue)
                    observationData.numberOfObservations++
                    let dataTableDataRow = {timestamp: timestamp, value:roundedObsRowValueForDataTable}
                    observationData.dataTableRows.push(dataTableDataRow)
                }

                return observationData

            },

            getRowDataTime(obsRow) {
                let tempTime = new Date(obsRow.time)
                let rowTime = {
                    s: tempTime.getSeconds(),
                    m: tempTime.getMinutes(),
                    h: tempTime.getHours(),
                    dd: tempTime.getDate(),
                    mm: tempTime.getMonth()+1,
                    yyyy: tempTime.getFullYear()
                }

                return this.pad(rowTime.dd)
                    + "." + this.pad(rowTime.mm)
                    + "." + rowTime.yyyy
                    + " " + this.pad(rowTime.h)
                    + ":" + this.pad(rowTime.m)
                    + ":" + this.pad(rowTime.s)
            },


            pad(timePart) {
                return (timePart < 10) ? ("0" + timePart) : timePart
            },

            formatChartData(observationSet, chartCanvas) {
                let valuesMeta = this.getValuesMeta(observationSet)

              if (!this.formattedObservationSets.includes(observationSet.variable || observationSet.title)) {
                observationSet.timeLabels.reverse()
                observationSet.tempDataset.reverse()

                observationSet = this.setDatasetDetails(observationSet)
                observationSet = this.setYAxesData(observationSet)
                observationSet = this.setXAxesData(observationSet)
                this.formattedObservationSets.push(observationSet.variable || observationSet.title)
              }

                let dataString = {
                    labels: observationSet.timeLabels,
                    datasets: observationSet.dataSetDetails
                };

                chartCanvas.height = 400
                chartCanvas.width = 640

                return {
                    chartCanvas: chartCanvas,
                    dataString: dataString,
                    xAxesData: observationSet.xAxesData,
                    yAxesData: observationSet.yAxesData,
                    timeLabels: observationSet.timeLabels,
                    valuesMeta: valuesMeta,
                    chartType: observationSet.chartType,
                }

            },

            getValuesMeta(observationSet) {
                let min = Math.min.apply(Math, observationSet.allValues)
                let max = Math.max.apply(Math, observationSet.allValues)
                let average = this.getAverage(observationSet.allValues)
                let median = this.getMedian(observationSet.allValues)
                let first = this.getFirstValue(observationSet.tempDataset)
                let last = this.getLastValue(observationSet.tempDataset)
                let unit = observationSet.unit

                return {
                        min: min,
                        max: max,
                        average: average,
                        median: median,
                        first: first,
                        last: last,
                        unit: unit
                    }
            },
            getAverage(values) {
                let sum = values.reduce((previous, current) => {
                    current = parseFloat(current) + parseFloat(previous)
                    return current
                })
                let avg = sum / values.length;
                let roundedAvg = Math.round(avg * 100) / 100
                return roundedAvg
            },
            getMedian(values) {
                var median = 0, numsLen = values.length;
                 values.sort();

                if (numsLen % 2 === 0) {
                    let sumOfTwoMiddle = parseFloat(values[numsLen / 2 - 1]) + parseFloat(values[numsLen / 2])
                    median = sumOfTwoMiddle/2

                } else {
                    median = values[(numsLen - 1) / 2];
                }

                let roundedMedian = Math.round(median * 100) / 100
                return roundedMedian
            },
            getFirstValue(values) {
                let firstValue = values[values.length-1]
                return firstValue
            },
            getLastValue(values) {
                let lastValue = values[0]
                return lastValue
            },
            setDatasetDetails(observationSet) {
            if (observationSet.dataSetDetails.length > 0) {
              return observationSet
            }
                let colors = []
                let loops = this.amountOfCharts / 6;

                for (let i = 0; i < loops; i++) {
                    colors.push("rgba(5,169,245,1)")
                    colors.push("rgba(103,59,183,1)")
                    colors.push("rgba(252,192,48,1)")
                    colors.push("rgba(243,67,54,1)")
                    colors.push("rgba(26,163,255,1)")
                    colors.push("rgba(80,225,90,1)")
                }

                observationSet.dataSetDetails.push(
                    {
                        label: (observationSet.title).replace('_', ' '),
                        backgroundColor: colors[observationSet.sort],
                        borderColor: colors[observationSet.sort],
                        data: observationSet.tempDataset,
                        yAxisID: "y-axis-1",
                        fill: false
                    }
                );
                return observationSet
            },

            setYAxesData(observationSet) {

                let ticks = this.getSmallestLargestAndScaleStep(observationSet)
                observationSet.yAxesData.push(
                    {
                        display: true,
                        position: "left",
                        id: "y-axis-1",
                        scaleLabel: {
                            display: false,
                            labelString: 'Value'
                        },
                        ticks: {
                            max: ticks.largestForGraph,
                            min: ticks.smallestForGraph,
                            stepSize: ticks.scaleStep
                        }
                    }
                );
                return observationSet
            },

            setXAxesData(observationSet) {
                observationSet.xAxesData.push(
                    [{
                        ticks: {
                            autoSkip: true,
                            maxTicksLimit: 30,
                            callback: function(value, index, values) {
                                return value.split(' ')[0]
                            }
                        }
                    }]
                );
                return observationSet
            },

            getSmallestLargestAndScaleStep(observationSet) {
                let smallest = Math.min.apply(Math, observationSet.allValues)
                let largest = Math.max.apply(Math, observationSet.allValues)
                let scaleStep = null

                let values = {
                    smallestForGraph: Math.floor(smallest),
                    largestForGraph: Math.ceil(largest),
                    scaleStep: scaleStep
                }

                let startFromZero = this.$store.getters.startGraphFromZero
                if (startFromZero) {
                    values = this.setGraphStartFromZero(values)
                }

                return values

            },

            setGraphStartFromZero(values) {

                let smallestForGraph = (values.smallestForGraph > 0) ? 0 : values.smallestForGraph
                let scaleDifference = values.largestForGraph - smallestForGraph
                let scaleStep = Math.ceil(scaleDifference / 10)

                let largestForGraph = this.roundToNext(scaleStep, values.largestForGraph)
                largestForGraph = largestForGraph + scaleStep

                return {
                    smallestForGraph: smallestForGraph,
                    largestForGraph: largestForGraph,
                    scaleStep: scaleStep
                }
            },

            roundToNext(number, x) {
                if(number != 0) {
                    return Math.ceil(x / number) * number
                }
                return 0;
            },

            createChart(chartData, maintainAspectRatio = false) {
                let chart = new Chart(chartData.chartCanvas.getContext('2d'), {
                    type: chartData.chartType,
                    data: chartData.dataString,
                    options: {
                        maintainAspectRatio: maintainAspectRatio,
                        elements: {
                            line: {
                                tension: 0.1,
                            },
                            point: {
                                radius: 0,
                            }
                        },
                        bezierCurve: false,
                        legend: {
                            display: true
                        },
                        responsive: true,
                        title:{
                            display: false
                        },
                        tooltips: {
                            mode: 'index',
                            intersect: false,
                            callbacks: {
                                label: function(tooltipItems, data) {
                                    return data.datasets[tooltipItems.datasetIndex].label +': ' + tooltipItems.yLabel
                                }
                            }
                        },
                        hover: {
                            mode: 'nearest',
                            intersect: true
                        },
                        scales: {
                            xAxes: chartData.xAxesData,
                            yAxes: chartData.yAxesData
                        }
                    }
                })
              chart.chartCanvas = chartData.chartCanvas
                return chart

            },

            setChartValuesMeta(chartCanvas, valuesMeta) {

                let avgElement = document
                    .getElementById(chartCanvas.id + 'average')

                avgElement.innerHTML = valuesMeta.average

                let medianElement = document
                    .getElementById(chartCanvas.id + 'median')

                medianElement.innerHTML = valuesMeta.median

                let minElement = document
                    .getElementById(chartCanvas.id + 'min')

                minElement.innerHTML = valuesMeta.min

                let maxElement = document
                    .getElementById(chartCanvas.id + 'max')

                maxElement.innerHTML = valuesMeta.max

                let firstElement = document
                    .getElementById(chartCanvas.id + 'first')

                firstElement.value = valuesMeta.first

                let lastElement = document
                    .getElementById(chartCanvas.id + 'last')

                lastElement.value = valuesMeta.last
            },

            handleNoDeviceData() {
                this.noDevices = true
            },

            async setTableData(observationSets) {
                if (this.datatable) {
                    this.datatable.destroy()
                }
                let allTimestamps = this.getAllTimestamps(observationSets)

                let headers = []
                for (let observationSet of observationSets) {
                  if (observationSet.visible) {
                    headers.push((observationSet.title).replace('_', ' '));
                  }
                }
                headers.push("AIKALEIMA")

                this.tableData.headers = headers
                this.tableData.rows = []

                let originalData = [];

                let deviceId = 0;
                for (let timestamp of allTimestamps) {

                    let timestampData = []

                    for (var observationSet of observationSets) {
                      if (!observationSet.visible) {
                        continue
                      }
                        deviceId =  observationSet.id

                        var valueForTimestamp = observationSet.dataTableRows.find(function(row) {
                            return row.timestamp === timestamp
                        });

                        if (!valueForTimestamp) {
                            timestampData.push('')
                        } else {
                            timestampData.push(valueForTimestamp.value)
                        }

                    }

                    originalData.push(timestampData)
                    timestampData.push(timestamp);
                    this.tableData.rows.push(timestampData)
                }

                originalData.id = deviceId
                let promise = this.$store.dispatch('addOriginalData', originalData)
                this.datatableReadyToInitialize = true;
            },

            getAllTimestamps(observationSets) {
                var allTimeLabels = []
                for (let observationSet of observationSets) {
                  if (observationSet.visible) {
                    for (let timelabel of observationSet.timeLabels) {
                      if (allTimeLabels.indexOf(timelabel) === -1) {
                        allTimeLabels.push(timelabel)
                      }
                    }
                  }
                }
                return allTimeLabels
            },
            addFilter() {
                let object = {
                    deviceId: this.deviceId,
                    filter: {
                        name: '',
                        value: '',
                        operand: '',
                    }
                }

                let filter_name = $('#filter_component_'+this.deviceId+' .filter_options option:selected')
                let filter_value = $('#filter_component_'+this.deviceId+' .filter_value')
                let filter_operand = $('#filter_component_'+this.deviceId+' .filter_operand option:selected')

                object.filter.name = filter_name.val()
                object.filter.value = filter_value.val()
                object.filter.operand = filter_operand.val()

                if (
                    !object.filter.name ||
                    !object.filter.value ||
                    !object.filter.operand
                ) {
                    alert("Filtteri tarvitsee kaikki arvot toimiakseen")
                    return false;
                }

                filter_value.val("")
                $('#filter_component_'+this.deviceId+' select').val([])

                let promise = this.$store.dispatch('addFilterForDevice', object)
                promise.then(() => {
                    this.datatable.draw()
                })
            },
            removeFilter(filter) {
                let promise = this.$store.dispatch('removeFilterFromDevice', {device_id: this.deviceId, filter: filter})
                promise.then(() => {
                    this.datatable.draw()
                })
            },
            modifyDecimals() {

                let column = $('#round_component_'+this.deviceId+' .round_options option:selected')
                let type = $('#round_component_'+this.deviceId+' .round_type option:selected')

                let object = {
                    deviceId: this.deviceId,
                    column: column.val(),
                    type: type.val()
                }

                let promise = this.$store.dispatch('modifyDatatableDecimals', object)
                    promise.then(() => {
                        this.roundValues(this.deviceId)
                })

            },
            roundValues(){

                let roundings = this.$store.getters.roundings[this.deviceId];
                let originalDatatableValues = this.$store.getters.originalValues[this.deviceId];

                if(roundings.columnName != null && roundings.type != null){
                    let index = this.tableData.headers.indexOf(roundings.columnName)

                    if (index < 0) {
                        return false;
                    }

                    let stringOfFirstValue = String(originalDatatableValues[0][index])
                    let checkNumeric = parseFloat(originalDatatableValues[0][index]);
                    if(isNaN(checkNumeric)){
                        alert("Pyöristys onnistuu vain numeroarvoille")
                        return false
                    }

                    let aikaleimaIndex = this.tableData.headers.indexOf("AIKALEIMA")

                    this.datatable.rows().every( function ( rowIdx, tableLoop, rowLoop ) {

                        let data = this.data();

                        let originalValue;
                        for(let i in originalDatatableValues){
                            if(originalDatatableValues[i][aikaleimaIndex] == data[aikaleimaIndex]){
                                originalValue = originalDatatableValues[i][index]
                            }
                        }

                        if(typeof originalValue == "string"){
                            originalValue = originalValue.replace(',', '.');
                        }

                        let float_value = parseFloat(originalValue)
                        let fixed_rounding = float_value.toFixed(roundings.type)
                        data[index] = fixed_rounding
                        this.row(rowIdx).data(data);

                    } );
                }


                this.datatable.draw();


            },
            recreateChart(index, chartType){
                //Change specific chart type and save it to observation store
                let observationsFromStore = this.$store.getters.devicesObservations
                let observationSets = observationsFromStore[this.deviceId]
                observationSets[index-1].chartType = chartType
                this.observationTypes[this.deviceId][index-1] = chartType

                //...then reload all the charts to display results
                this.saveObservationsToStore(observationSets)
                this.recreateCharts()
            },
            async recreateCharts() {
              await this.$nextTick()
              await this.getAndSetDeviceObservations(this.deviceId, this.times, this.visibleObservations)
            },
            refreshSliders() {
                this.$nextTick(() => {
                    if (this.$refs.slider) {
                        this.$refs.slider.forEach(s => {
                            if(s.refresh instanceof Function){
                                s.refresh();
                            }
                        });
                    }
                })
            },
          initializeTable() {
            if (this.datatableReadyToInitialize) {
              let tableId = this.tableTagId;
              let tableElement = $('#' + tableId);

              // Check if the table element exists
              if (tableElement.length) {
                // Check if DataTable is already initialized
                if ($.fn.DataTable.isDataTable(tableElement)) {
                  // Destroy the existing DataTable
                  let dataTableInstance = tableElement.DataTable();
                  if (dataTableInstance && dataTableInstance.table().node() && dataTableInstance.table().node().parentNode) {
                    dataTableInstance.destroy();
                  }
                  tableElement.find('thead').empty(); // Clear existing headers
                }

                // Set headers before initializing DataTable
                let headersHtml = '<tr>';
                this.tableData.headers.forEach(header => {
                  headersHtml += `<th>${header}</th>`;
                });
                headersHtml += '</tr>';
                tableElement.find('thead').html(headersHtml);

                this.datatable = tableElement.DataTable({
                  "dom": "Blfrtip",
                  "deviceId": this.deviceId,
                  buttons: [
                    {
                      extend: 'csv',
                      fieldSeparator: ';',
                      filename: this.deviceName
                    },
                    // other buttons
                  ],
                  "language": {
                    "sEmptyTable": "Ei näytettäviä tuloksia.",
                    "sInfo": "Näytetään rivit _START_ - _END_ (yhteensä _TOTAL_ )",
                    "sInfoEmpty": "Näytetään 0 - 0 (yhteensä 0)",
                    "sInfoFiltered": "(suodatettu _MAX_ tuloksen joukosta)",
                    "sLengthMenu": "Näytä kerralla _MENU_ riviä",
                    "sLoadingRecords": "Ladataan...",
                    "sProcessing": "Hetkinen...",
                    "sSearch": "Etsi:",
                    "sZeroRecords": "Tietoja ei löytynyt",
                    "oPaginate": {
                      "sFirst": "Ensimmäinen",
                      "sLast": "Viimeinen",
                      "sNext": "Seuraava",
                      "sPrevious": "Edellinen"
                    },
                    "oAria": {
                      "sSortAscending": ": lajittele sarake nousevasti",
                      "sSortDescending": ": lajittele sarake laskevasti"
                    },
                    "select": {
                      "rows": {
                        // select rows options
                      }
                    },
                    "buttons": {
                      "copy": "Kopioi",
                      "copySuccess": {
                        // copy success options
                      },
                      "copyTitle": "Kopioi leikepöydälle",
                      "copyKeys": "Paina <i>ctrl</i> tai <i>\\u2318</i> + <i>C</i> kopioidaksesi taulukon arvot<br>järjestelmäsi leikepöydälle. <br><br>Peruuttaaksesi paina tätä viestiä tai Esc."
                    }
                  },
                  "lengthMenu": [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                  "order": [[this.tableData.headers.length - 1, "desc"]],
                  columnDefs: [
                    { type: 'date-euro', targets: this.amountOfCharts }
                  ],
                  "paging": true,
                });

                if ($('#filter_component_' + this.deviceId + ' .filter_options option').length === 1) {
                  $('#filter_component_' + this.deviceId + ' .filter_options').empty(); // Clear existing options
                  $('#' + this.tableTagId + ' thead th').each((k, v) => {
                    let option = document.createElement('option');
                    option.value = v.textContent;
                    option.text = v.textContent;
                    $('#filter_component_' + this.deviceId + ' .filter_options').append(option);
                  });
                }

                if ($('#round_component_' + this.deviceId + ' .round_options option').length === 0) {
                  $('#round_component_' + this.deviceId + ' .round_options').empty(); // Clear existing options
                  $('#' + this.tableTagId + ' thead th').each((k, v) => {
                    let option = document.createElement('option');
                    option.value = v.textContent;
                    option.text = v.textContent;
                    if (option.text != "AIKALEIMA") {
                      $('#round_component_' + this.deviceId + ' .round_options').append(option);
                    }
                  });
                }

                EventBus.$emit('datatable', this.datatable);
                this.datatableReadyToInitialize = false;
              }
            }
          }
        },
        computed: {
          visibleObservations() {
            const visible = this.observationSets.filter(observation => observation.visible);
            return visible;
          },
            times: function () {
                return this.parent_times
            },
            filters: function() {
                let f = this.$store.state.filters.filters[this.deviceId];
                return f ? f : {};
            },
            roundings: function() {
                let r = this.$store.state.roundings.roundings[this.deviceId];
                return r ? r : {};
            },
            showRangeSliders() {
                return this.$store.getters.showRangeSliders
            },
            showCombinationCharts() {
                return this.$store.getters.showCombinationCharts
            },
            updateCombinationChart() {
                return this.$store.getters.combinationChartUpdateData
            }
        },
        async mounted() {
            await this.getAndSetDeviceObservations(this.deviceId, this.times);
            await this.$nextTick()
        },
        watch: {
            'times.start':  function (newval) {
                this.$store.dispatch('removeObservationSetsFromStore')
                this.times.start = newval
                this.recreateCharts()
            },
            'times.end': function (newval) {
                this.$store.dispatch('removeObservationSetsFromStore')
                this.times.end = newval
                this.recreateCharts()
            },
            'updateCombinationChart': function(combinationChartData) {
                if (combinationChartData.id === this.deviceId) {
                    this.setCombinationChart(combinationChartData)
                }
            },
            parentShowSmallCharts: function() {
                this.recreateCharts()
            },
            parentStartGraphFromZero: function() {
                this.recreateCharts()
            },

        },
        beforeDestroy() {
            this.destroyOldCharts()
        },

        updated() {
            /*this.$nextTick(function () {
                if(this.datatable) {
                    this.datatable.page.len(10).draw();
                }
            });*/
            this.initializeTable();
        }
    }
</script>

<style scoped>

    .dataTableContainer {
        width: 95%;
        max-width: 1600px;
        margin: auto;
        margin-top: 30px;
        font-size: 0.7rem;
        color: #000;
    }

    .status-indicator {
        color: #000;
        font-size: 30px;
        text-align: center;
        margin-top: 10%;
    }

    .active_filter {
        display: inline-block;
        font-size: 9px;
        padding: 0.25em;
        background: darkkhaki;
        margin: 1px;
        border-radius: 2px;
    }
    .active_filter button {
        padding: 1px;
        line-height: 1;
        color: seashell;
        border-style: none;
        background: transparent;
    }
    .filter_component, .round_component {
        padding: 0 15px;
    }
    .red-x {
        color: darkred;
        margin-left: 3px;
        margin-right: 3px;
    }

    .extra_text_component {
        padding: 0 15px;
        padding-bottom: 32px;
    }
    .extra_text_field {
        width: 100%;
    }
    .days-in-ranges {
        color: #000;
    }
    .days-in-ranges-values {
        font-size: 5.5em;
        text-align: center;
        border: solid #c9c9c9 6px;
        border-style: dashed;
        border-radius: 30px;
        width: 42%;
        margin: auto;
        font-weight: bold;
        height: 100px;
        padding: 30px;
        line-height: 20px;
    }
    .out-of-range {
        color: red;
    }
    .in-range {
        color: green;
    }

    .good-days {
        width: 95%;
        display: block;
        margin: auto;
        margin-bottom: 32px;
    }
    .slider-label {
        float:left; display:inline; width: 20%;

    }
    .range-slider {
        /*float:left; display:inline; width: 49%;*/
        width: 80%;
        float: left;
        margin-bottom: 33px;
    }
    .slider-day-labels {
        color: black;
        text-align: center;
    }
    .in-range-label {
        color: green;
    }
    .out-of-range-label {
        color:red
    }
    .slider-description {
        color: black;
        margin: 20px;
        margin-bottom: 50px;
        padding: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #f5f5f5;
    }
    .section-header h2 {
        color: #000;
        margin-bottom: 20px;
        font-size: 25px;
    }
    .dot-spinner {
        margin: auto;
        padding-top: 20px;
    }
    .label-chart-checkbox {
      color: black;
    }

</style>



// WEBPACK FOOTER //
// src/app/Main/components/DeviceData.vue